import { linkColors } from 'shared/constants/menu-colors';

// temporary solution for legal user locations
const LEGAL_STATES = [
  'AZ',
  'AK',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IL',
  'IA',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MS',
  'MN',
  'MO',
  'MT',
  'NV',
  'NH',
  'NJ',
  'NM',
  'ND',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'SD',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
];

const defaultThemeColor = `#0B99E6`;

export const getIsUserInLegalMarket = (state: string): boolean => LEGAL_STATES.includes(state);

export const getThemeColorForDispensary = ({ colorKey }: { colorKey: string }): string => {
  const selectedColor = linkColors.filter(({ key }) => key === colorKey);

  return selectedColor.length > 0 ? selectedColor[0].background : defaultThemeColor;
};
